import i18next from "i18next";

const changeLanguage = (lang) => {
    i18next.changeLanguage(lang);
}

export default changeLanguage;